<template>
  <Teleport to="body">
    <div ref="modal" :class="['popup', 'modal', { 'is-active': open }]" @keydown.esc="close" tabindex="-1">
      <div class="modal-background" @click="close"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <div class="modal-card-head-main">
            <h1 class="modal-card-title">{{ `${appDisplayName} Help` }}</h1>
            <button ref="closeButton" class="delete" aria-label="close" @click="close"></button>
          </div>
          <p class="modal-card-description is-size-6" v-html="description"></p>
          <a v-if="learnMoreUrl != null" :href="learnMoreUrl" class="is-size-6 is-block has-text-left mt-2"
             target="_blank" rel="noopener">
            {{ learnMoreText }}
          </a>
        </header>
        <section class="modal-card-body">
          <slot></slot>
        </section>
        <footer class="modal-card-foot is-flex is-justify-content-center">
          <button type="button" class="button is-link is-size-6" @click="is_popup_open = false">
            Go to {{ appDisplayName }}
          </button>
        </footer>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import {inject, ref, watch, nextTick} from "vue";

const is_popup_open = inject("is_popup_open");
const appDisplayName = inject('appDisplayName');
const learnMoreText = inject("learnMoreText");
const learnMoreUrl = inject("learnMoreUrl");

const props = defineProps({
  open: {type: Boolean, default: false},
  title: {type: String},
  description: {type: String}
});

const emit = defineEmits(['dismiss']);

const closeButton = ref(null);

// put focus on close button after modal opens
watch(
    () => props.open,
    async (isOpen) => {
      if (!isOpen) return;
      await nextTick();
      closeButton.value?.focus();
    },
    { immediate: true }
);

const close = () => {
  emit("dismiss");
};
</script>

<style lang="scss" scoped>
div {
  text-align: center;
}

h1 {
  text-align: left;
}

.modal-card-head {
  flex-direction: column;
  align-items: stretch;
  padding-top: 16px;
  padding-bottom: 16px;
  background-color: #F5F5F5;
}

.modal-card-head-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.modal-card-description {
  margin-top: 8px;
  padding-right: 20px;
  text-align: left;
}

::v-deep(img) {
  padding-top: 10px;
}
</style>